(function () {
  'use strict';

  angular
    .module('applicationParameters')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('applicationParameters', {
        url: '/application-parameters',
        views : {
			'applicationParametersView' : {
				templateUrl: 'application-parameters/views/application-parameters.tpl.html',
		        controller: 'ApplicationParametersCtrl',
		        controllerAs: 'applicationParameters'
			}
		}
        
      });
  }
}());
